import { YEARLY_DISCOUNT_PCT } from '@/lib/billing';

// Compact Monthly / Yearly switch for in-app billing screens (Upgrade page, Settings → Billing).
export const BillingIntervalToggle = ({ value, onChange, className = '' }) => {
  const yearly = value === 'year';
  return (
    <div className={`inline-flex items-center rounded-full bg-white/[0.04] border border-white/[0.08] p-1 ${className}`} data-testid="billing-interval-toggle" role="radiogroup">
      <button type="button" role="radio" aria-checked={!yearly} onClick={() => onChange('month')} data-testid="billing-interval-month"
        className={`px-4 py-1.5 rounded-full text-xs font-semibold transition-colors ${!yearly ? 'bg-white text-zinc-950' : 'text-white/55 hover:text-white/85'}`}>
        Monthly
      </button>
      <button type="button" role="radio" aria-checked={yearly} onClick={() => onChange('year')} data-testid="billing-interval-year"
        className={`px-3 py-1.5 rounded-full text-xs font-semibold inline-flex items-center gap-1.5 transition-colors ${yearly ? 'bg-white text-zinc-950' : 'text-white/55 hover:text-white/85'}`}>
        Yearly
        <span className={`text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded ${yearly ? 'bg-zinc-950/15 text-zinc-950' : 'bg-emerald-500/15 text-emerald-300 border border-emerald-500/30'}`}>
          Save {YEARLY_DISCOUNT_PCT}%
        </span>
      </button>
    </div>
  );
};

export default BillingIntervalToggle;
